/*@ngInject*/
const UserListActionsUtil = function ($rootScope, $state, userMediator, userListActionMediator, modalUtil, coreConstant, loadingBarHandler, fileExportUtil, localization) {

    localization.getTranslationByKey('userList').then(function (translations) {

        this.createUser = function (userType) {
            let promise = userMediator.createNewUser(userType).then(function (user) {
                $state.go('manageUser', {userId: user.id, userType: userType});
            });
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        };

        this.importUWLOAs = function (file) {
            let promise;
            loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'importUWLOAs.loadingBar'));
            promise =  userListActionMediator.importUWLOAs(file).then(function (result) {
                let resultSplits = _.split(result, '\n'),
                    successfulImports = parseInt(_.trim(resultSplits[1].substring(_.indexOf(resultSplits[1], '-') + 1))),
                    failedImports = parseInt(_.trim(resultSplits[2].substring(_.indexOf(resultSplits[2], '-') + 1))),
                    failedReasons,
                    config,
                    summary;

                if (failedImports === 0) {
                    loadingBarHandler.concludeNotificationLoadingBar(_.replace(_.get(translations, 'importUWLOAs.' + (successfulImports === 1 ? 'successMessageSingular' : 'successMessagePlural')), '{0}', successfulImports));
                } else {
                    loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);

                    // Remove the first 4 entries of the resultSplits array, which is everything except the failed reasons,
                    // then join those reasons back together to display in the client:
                    resultSplits.splice(0, 4);
                    failedReasons = _.join(resultSplits, '\n');

                    summary = _.get(translations, 'importUWLOAs.errorModal.summary');
                    summary = _.replace(summary, '{0}', successfulImports);
                    summary = _.replace(summary, '{1}', failedImports);
                    summary = _.replace(summary, '{2}', failedReasons);

                    config = {
                        confirmActionButtonLabel: _.get(translations, 'importUWLOAs.errorModal.confirmActionButtonLabel'),
                        summary: summary,
                        title: _.get(translations, 'importUWLOAs.errorModal.title')
                    };

                    modalUtil.showGenericConfirm(config);
                }
            }, function () {
                // On Error
                loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
            });
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        };

        this.exportUWLOAs = function () {
            let promise;
            loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'exportUWLOAs.loadingBar'));
            promise = userListActionMediator.exportUWLOAs().then(function (result) {
                let filename = 'userLOAExport.xml';

                loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'exportUWLOAs.successMessage'));

                fileExportUtil.saveAs(result, 'application/xml', filename);
            }, function () {
                // On Error
                loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
            });
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        };
    }.bind(this));
};

angular.module('umCore')
    .service('userListActionsUtil', UserListActionsUtil);
